import { Link } from 'react-router-dom';
import { mediaList } from '@/mocks/media';
import type { MediaType } from '@/types/media';

const SHORTCUTS: { type: MediaType; label: string; desc: string; icon: string; color: string }[] = [
  {
    type: 'movie',
    label: '电影',
    desc: '院线热映 · 高分佳作',
    icon: 'ri-film-line',
    color: 'bg-primary-500',
  },
  {
    type: 'tv',
    label: '电视剧',
    desc: '热播剧集 · 追剧不停',
    icon: 'ri-tv-2-line',
    color: 'bg-accent-500',
  },
  {
    type: 'variety',
    label: '综艺',
    desc: '综艺真人秀 · 轻松一刻',
    icon: 'ri-mic-line',
    color: 'bg-secondary-700',
  },
];

export default function CategoryShortcuts() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-1 gap-3">
      {SHORTCUTS.map((item) => {
        const count = mediaList.filter((m) => m.type === item.type).length;
        return (
          <Link
            key={item.type}
            to={`/category/${item.type}`}
            className="group flex items-center gap-3 p-3.5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 hover:-translate-y-0.5"
          >
            <span className={`w-12 h-12 rounded-lg ${item.color} text-background-50 flex items-center justify-center shrink-0`}>
              <i className={`${item.icon} text-2xl`}></i>
            </span>
            <span className="flex flex-col min-w-0">
              <span className="text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                {item.label}
              </span>
              <span className="text-xs text-foreground-500 truncate">{item.desc}</span>
            </span>
            <span className="ml-auto text-xs text-foreground-400 whitespace-nowrap">{count} 部</span>
            <i className="ri-arrow-right-s-line text-xl text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
          </Link>
        );
      })}
    </div>
  );
}